/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    WebhookListener,
    WebhookListenerFromJSON,
    WebhookListenerToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectWebhooksListResult
 */
export interface ProjectWebhooksListResult {
    /**
     * 
     * @type {Array<WebhookListener>}
     * @memberof ProjectWebhooksListResult
     */
    webhooks: Array<WebhookListener>;
}

export function ProjectWebhooksListResultFromJSON(json: any): ProjectWebhooksListResult {
    return {
        
        'webhooks': (json['webhooks'] as Array<any>).map(WebhookListenerFromJSON),
        
    };
}

export function ProjectWebhooksListResultToJSON(value?: ProjectWebhooksListResult): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        
        'webhooks': (value.webhooks as Array<any>).map(WebhookListenerToJSON),
        
    };
}


